<template>
  <Sector v-if="listExist(name)">
    <Subtitle v-if="title">
      <template #text>
        <prismic-rich-text :field="title" class="collections-carousel-title"></prismic-rich-text>
      </template>
      <template #side><BadgeNew :height="20" /></template>
    </Subtitle>
    <Carousel
      :items="getCollectionList(name)"
      :height="carouselCollectionHeight"
      :margin-bottom="45"
      :see-more-enabled="true"
      :see-more-link="seeMorePath"
      :show-bottom-bar="true"
      :is-grouper="true"
      :is-collection="true"
    >
      <template #bottomBar="slotProps">
        <CollectionsBottomBar :data="slotProps.data" />
      </template>
    </Carousel>
  </Sector>
</template>

<script>
import Carousel from '@/components/Common/Carousel';
import CollectionsBottomBar from '@/components/Collections/CollectionsBottomBar';
import Subtitle from '@/components/Home/Subtitle';
import Sector from '@/components/Home/Sector';
import BadgeNew from 'UI/Badges/New';
import { mapGetters } from 'vuex';
export default {
  components: {
    Carousel,
    CollectionsBottomBar,
    Subtitle,
    BadgeNew,
    Sector
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      ids: [],
      name: '',
      title: '',
      seeMorePath: '',
      carouselCollectionHeight: 230
    };
  },
  async fetch() {
    const inputName = this.slice.primary.collection_name[0]?.text;

    this.title = this.slice.primary?.title1[0]?.text ? this.slice.primary?.title1 : '';

    this.name = inputName
      ? inputName?.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase())
      : '';

    this.seeMorePath = this.slice.primary?.see_more_path[0]?.text
      ? this.localePath(this.slice.primary?.see_more_path[0]?.text)
      : this.$trailingSlash(this.localePath('collections'));

    this.slice.items.forEach((id) => {
      if (id.grouper_id) this.ids.push(id.grouper_id);
    });

    if (this.name && this.ids.length) {
      await this.$store.dispatch('collections/LOAD_COLLECTION_LISTING', {
        name: this.name,
        ids: this.ids
      });
    }
  },
  computed: {
    ...mapGetters('collections', ['listExist', 'getCollectionList'])
  },
  methods: {
    async vectorClick({ item, shownListing }, e) {
      e.preventDefault();
      this.$bvModal.show('preview-vector-modal');
      await this.$store.dispatch('vectors/OPEN_PREVIEW', { id: item.id, list: shownListing });
    }
  }
};
</script>

<style lang="scss" scoped>
.collections-carousel-title {
  font-weight: 500;
  margin: 5px 0 10px 5px;
}
</style>

<style lang="scss">
.collections-carousel-title {
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 1em;
  }
}
</style>
